<div class="default-dialog-wrapper mat-elevation-z10">
  <div class="flex flex-col pt-20 pr-26 pb-20 pl-26">

    <div class="flex flex-row justify-between align-items-start mb-12">
      <h1 class="mat-headline-5 fw-700 mb-0">{{ data.title }}</h1>
      <mat-icon svgIcon="close" class="cursor-pointer icon-lg" [matDialogClose]></mat-icon>
    </div>

    <p class="mat-subtitle-2 fw-400 tracking-normal mb-16 opacity-75">
      {{ data.description }}
    </p>

    <div class="video-wrapper mb-20">
      <iframe [src]="safeVideoUrl"
              allowfullscreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
      </iframe>
    </div>

    <mat-divider class="neutral-blue-7 w-100-percent mb-16"></mat-divider>

    <div class="flex justify-end">
      <button class="accent" (click)="proceed()">{{ 'SIZING_VIDEO_TUTORIAL.PROCEED' | transloco }}</button>
    </div>

  </div>
</div>
